// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snowflake-area {
  position: relative;
  width: 100%;
  height: 100%;
}
.snowflake-area--fading-out {
  animation: fadeOut 1s ease-out forwards;
}

.snowflake {
  position: absolute;
  top: -2vh;
  font-size: 10px;
  animation: fall linear infinite;
  opacity: 0.8;
}
.snowflake._md {
  font-size: 1.5em;
}
.snowflake._lg {
  font-size: 2.25em;
}
.snowflake._1 {
  left: 80vw;
  filter: blur(0px);
  animation: 2.5s flicker -1.5s infinite, 27s fall -4.2s infinite;
}
.snowflake._2 {
  left: 21vw;
  filter: blur(1px);
  animation: 2.3s flicker -1.2s infinite, 19.2s fall -19.6s infinite;
}
.snowflake._3 {
  left: 47vw;
  filter: blur(1px);
  animation: 2.2s flicker -1.4s infinite, 22.2s fall -10.8s infinite;
}
.snowflake._4 {
  left: 24vw;
  filter: blur(0px);
  animation: 3s flicker -0.3s infinite, 17s fall -7.4s infinite;
}
.snowflake._5 {
  left: 98vw;
  filter: blur(1px);
  animation: 2.5s flicker -1.5s infinite, 26.8s fall -1.4s infinite;
}
.snowflake._6 {
  left: 13vw;
  filter: blur(0px);
  animation: 3.8s flicker -1.4s infinite, 13.6s fall -4.4s infinite;
}
.snowflake._7 {
  left: -18vw;
  filter: blur(0px);
  animation: 2.5s flicker -0.3s infinite, 19.2s fall -1.2s infinite;
}
.snowflake._8 {
  left: -18vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.6s infinite, 27.2s fall -6.2s infinite;
}
.snowflake._9 {
  left: 28vw;
  filter: blur(0px);
  animation: 3.8s flicker -0.2s infinite, 21.2s fall -15s infinite;
}
.snowflake._10 {
  left: 62vw;
  filter: blur(0px);
  animation: 2.4s flicker -1s infinite, 27.8s fall -6s infinite;
}
.snowflake._11 {
  left: -2vw;
  filter: blur(1px);
  animation: 2.3s flicker -1.5s infinite, 14.8s fall -12.4s infinite;
}
.snowflake._12 {
  left: 9vw;
  filter: blur(0px);
  animation: 4s flicker -1s infinite, 29.6s fall -11.4s infinite;
}
.snowflake._13 {
  left: 71vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.8s infinite, 19s fall -15.6s infinite;
}
.snowflake._14 {
  left: 90vw;
  filter: blur(0px);
  animation: 2.9s flicker -1s infinite, 28.2s fall -18.6s infinite;
}
.snowflake._15 {
  left: 53vw;
  filter: blur(0px);
  animation: 3.8s flicker -1.8s infinite, 13.6s fall -9s infinite;
}
.snowflake._16 {
  left: -9vw;
  filter: blur(1px);
  animation: 3.7s flicker -0.3s infinite, 29.2s fall -15.2s infinite;
}
.snowflake._17 {
  left: 50vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.3s infinite, 16.4s fall -5.2s infinite;
}
.snowflake._18 {
  left: 17vw;
  filter: blur(0px);
  animation: 2.7s flicker -1.1s infinite, 27.8s fall -15s infinite;
}
.snowflake._19 {
  left: 96vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.8s infinite, 29s fall -10.6s infinite;
}
.snowflake._20 {
  left: 25vw;
  filter: blur(1px);
  animation: 3.6s flicker -0.1s infinite, 14.2s fall -10s infinite;
}
.snowflake._21 {
  left: 24vw;
  filter: blur(1px);
  animation: 3.5s flicker -0.3s infinite, 24.4s fall -9.2s infinite;
}
.snowflake._22 {
  left: 20vw;
  filter: blur(0px);
  animation: 2.6s flicker -1.9s infinite, 11.6s fall -7.6s infinite;
}
.snowflake._23 {
  left: -17vw;
  filter: blur(1px);
  animation: 3.5s flicker -0.8s infinite, 17.6s fall -8.8s infinite;
}
.snowflake._24 {
  left: 0vw;
  filter: blur(1px);
  animation: 3.6s flicker -0.1s infinite, 19.8s fall -8.4s infinite;
}
.snowflake._25 {
  left: 58vw;
  filter: blur(1px);
  animation: 2.9s flicker -1.8s infinite, 26.2s fall -15.4s infinite;
}
.snowflake._26 {
  left: 11vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.5s infinite, 12.4s fall -4.8s infinite;
}
.snowflake._27 {
  left: 93vw;
  filter: blur(1px);
  animation: 2.1s flicker -2s infinite, 26.8s fall -18.2s infinite;
}
.snowflake._28 {
  left: 87vw;
  filter: blur(0px);
  animation: 3s flicker -0.7s infinite, 21.6s fall -13.4s infinite;
}
.snowflake._29 {
  left: 73vw;
  filter: blur(1px);
  animation: 3.5s flicker -0.4s infinite, 19.6s fall -9.6s infinite;
}
.snowflake._30 {
  left: 57vw;
  filter: blur(1px);
  animation: 2.7s flicker -0.2s infinite, 20.2s fall -4.8s infinite;
}
.snowflake._31 {
  left: -8vw;
  filter: blur(1px);
  animation: 3.5s flicker -1.6s infinite, 24.4s fall -18.4s infinite;
}
.snowflake._32 {
  left: 69vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.9s infinite, 15.8s fall -7.6s infinite;
}
.snowflake._33 {
  left: 39vw;
  filter: blur(1px);
  animation: 2.1s flicker -1.5s infinite, 20.8s fall -15.2s infinite;
}
.snowflake._34 {
  left: 97vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.2s infinite, 14s fall -9.4s infinite;
}
.snowflake._35 {
  left: 4vw;
  filter: blur(0px);
  animation: 2.1s flicker -2s infinite, 25.8s fall -18.2s infinite;
}
.snowflake._36 {
  left: 22vw;
  filter: blur(0px);
  animation: 3s flicker -1.5s infinite, 11.2s fall -14s infinite;
}
.snowflake._37 {
  left: 80vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.9s infinite, 20.8s fall -14.6s infinite;
}
.snowflake._38 {
  left: 36vw;
  filter: blur(1px);
  animation: 2.8s flicker -0.8s infinite, 12.8s fall -18.4s infinite;
}
.snowflake._39 {
  left: 79vw;
  filter: blur(0px);
  animation: 3.9s flicker -0.8s infinite, 19s fall -9.8s infinite;
}
.snowflake._40 {
  left: 36vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.3s infinite, 17.6s fall -15.2s infinite;
}
.snowflake._41 {
  left: 29vw;
  filter: blur(1px);
  animation: 3s flicker -1.4s infinite, 29.8s fall -9.6s infinite;
}
.snowflake._42 {
  left: 12vw;
  filter: blur(0px);
  animation: 2.8s flicker -0.3s infinite, 15.6s fall -15.2s infinite;
}
.snowflake._43 {
  left: 83vw;
  filter: blur(1px);
  animation: 3.9s flicker -0.7s infinite, 17.6s fall -9.2s infinite;
}
.snowflake._44 {
  left: 6vw;
  filter: blur(0px);
  animation: 3s flicker -0.9s infinite, 20.8s fall -7s infinite;
}
.snowflake._45 {
  left: 13vw;
  filter: blur(0px);
  animation: 2.5s flicker -1.9s infinite, 19.4s fall -5s infinite;
}
.snowflake._46 {
  left: 21vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.1s infinite, 18s fall -11s infinite;
}
.snowflake._47 {
  left: 85vw;
  filter: blur(1px);
  animation: 3.4s flicker -1.9s infinite, 28.6s fall -11.2s infinite;
}
.snowflake._48 {
  left: 32vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.6s infinite, 27.8s fall -7.6s infinite;
}
.snowflake._49 {
  left: -18vw;
  filter: blur(0px);
  animation: 2.2s flicker -1.5s infinite, 26.2s fall -8.6s infinite;
}
.snowflake._50 {
  left: 17vw;
  filter: blur(0px);
  animation: 3.1s flicker -1.8s infinite, 23s fall -3.4s infinite;
}
.snowflake._51 {
  left: -4vw;
  filter: blur(0px);
  animation: 2.6s flicker -1.8s infinite, 14s fall -15.2s infinite;
}
.snowflake._52 {
  left: -2vw;
  filter: blur(0px);
  animation: 3.5s flicker -1.2s infinite, 11.2s fall -9.6s infinite;
}
.snowflake._53 {
  left: 52vw;
  filter: blur(1px);
  animation: 3.7s flicker -0.8s infinite, 18.6s fall -8.4s infinite;
}
.snowflake._54 {
  left: -3vw;
  filter: blur(0px);
  animation: 2.4s flicker -0.2s infinite, 16.4s fall -17.2s infinite;
}
.snowflake._55 {
  left: -5vw;
  filter: blur(1px);
  animation: 3.3s flicker -1.5s infinite, 11.6s fall -8s infinite;
}
.snowflake._56 {
  left: 65vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.3s infinite, 19.4s fall -9s infinite;
}
.snowflake._57 {
  left: -13vw;
  filter: blur(0px);
  animation: 3.3s flicker -2s infinite, 25.2s fall -9.2s infinite;
}
.snowflake._58 {
  left: -18vw;
  filter: blur(0px);
  animation: 3.6s flicker -1.4s infinite, 16.6s fall -13.4s infinite;
}
.snowflake._59 {
  left: 14vw;
  filter: blur(0px);
  animation: 2.7s flicker -1.5s infinite, 20s fall -14.2s infinite;
}
.snowflake._60 {
  left: 77vw;
  filter: blur(0px);
  animation: 3s flicker -0.9s infinite, 13.4s fall -19.2s infinite;
}
.snowflake._61 {
  left: 91vw;
  filter: blur(0px);
  animation: 2.3s flicker -0.7s infinite, 18.2s fall -6.2s infinite;
}
.snowflake._62 {
  left: 65vw;
  filter: blur(0px);
  animation: 3s flicker -0.4s infinite, 19.6s fall -16s infinite;
}
.snowflake._63 {
  left: 75vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.8s infinite, 16s fall -2.8s infinite;
}
.snowflake._64 {
  left: 38vw;
  filter: blur(0px);
  animation: 3s flicker -0.7s infinite, 25.6s fall -13s infinite;
}
.snowflake._65 {
  left: 77vw;
  filter: blur(1px);
  animation: 3.3s flicker -0.4s infinite, 23.8s fall -14.6s infinite;
}
.snowflake._66 {
  left: 58vw;
  filter: blur(0px);
  animation: 4s flicker -0.2s infinite, 24.4s fall -9.6s infinite;
}
.snowflake._67 {
  left: 75vw;
  filter: blur(0px);
  animation: 3.7s flicker -1.7s infinite, 26.6s fall -8s infinite;
}
.snowflake._68 {
  left: 7vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.4s infinite, 16s fall -10.4s infinite;
}
.snowflake._69 {
  left: 59vw;
  filter: blur(1px);
  animation: 3.7s flicker -0.8s infinite, 24.2s fall -11.8s infinite;
}
.snowflake._70 {
  left: 80vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.1s infinite, 19.2s fall -0.8s infinite;
}
.snowflake._71 {
  left: 65vw;
  filter: blur(0px);
  animation: 2.8s flicker -0.7s infinite, 17.8s fall -15s infinite;
}
.snowflake._72 {
  left: 56vw;
  filter: blur(0px);
  animation: 2.6s flicker -1.5s infinite, 22.6s fall -1.6s infinite;
}
.snowflake._73 {
  left: 88vw;
  filter: blur(0px);
  animation: 3.8s flicker -0.8s infinite, 26.4s fall -12.8s infinite;
}
.snowflake._74 {
  left: 82vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.8s infinite, 15s fall -15.8s infinite;
}
.snowflake._75 {
  left: 68vw;
  filter: blur(1px);
  animation: 3.1s flicker -0.9s infinite, 14.2s fall -14s infinite;
}
.snowflake._76 {
  left: -13vw;
  filter: blur(0px);
  animation: 2.1s flicker -1.9s infinite, 25.6s fall -0.6s infinite;
}
.snowflake._77 {
  left: -3vw;
  filter: blur(0px);
  animation: 2.8s flicker -1.4s infinite, 10.2s fall -8s infinite;
}
.snowflake._78 {
  left: 57vw;
  filter: blur(1px);
  animation: 3.4s flicker -1.5s infinite, 25.2s fall -2.4s infinite;
}
.snowflake._79 {
  left: 13vw;
  filter: blur(1px);
  animation: 2.3s flicker -0.4s infinite, 10.4s fall -5.8s infinite;
}
.snowflake._80 {
  left: 84vw;
  filter: blur(0px);
  animation: 3.1s flicker -0.6s infinite, 23.2s fall -9.2s infinite;
}
.snowflake._81 {
  left: 55vw;
  filter: blur(0px);
  animation: 2.5s flicker -2s infinite, 26.6s fall -1s infinite;
}
.snowflake._82 {
  left: -8vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.5s infinite, 29.4s fall -4.6s infinite;
}
.snowflake._83 {
  left: 31vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.8s infinite, 20.6s fall -7.2s infinite;
}
.snowflake._84 {
  left: 29vw;
  filter: blur(1px);
  animation: 3.2s flicker -1.6s infinite, 10.2s fall -8.2s infinite;
}
.snowflake._85 {
  left: 35vw;
  filter: blur(1px);
  animation: 2.2s flicker -0.1s infinite, 18.6s fall -4.6s infinite;
}
.snowflake._86 {
  left: -13vw;
  filter: blur(0px);
  animation: 4s flicker -0.5s infinite, 28.8s fall -4.4s infinite;
}
.snowflake._87 {
  left: 87vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.1s infinite, 22s fall -4.2s infinite;
}
.snowflake._88 {
  left: 51vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.5s infinite, 24.8s fall -10.2s infinite;
}
.snowflake._89 {
  left: 46vw;
  filter: blur(1px);
  animation: 3.6s flicker -0.2s infinite, 15.4s fall -16.2s infinite;
}
.snowflake._90 {
  left: 97vw;
  filter: blur(1px);
  animation: 3s flicker -1.7s infinite, 12s fall -15.6s infinite;
}
.snowflake._91 {
  left: -17vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.9s infinite, 27.2s fall -4.6s infinite;
}
.snowflake._92 {
  left: 86vw;
  filter: blur(1px);
  animation: 3.7s flicker -0.8s infinite, 21.8s fall -13.2s infinite;
}
.snowflake._93 {
  left: 71vw;
  filter: blur(1px);
  animation: 2.2s flicker -0.6s infinite, 12.8s fall -11.6s infinite;
}
.snowflake._94 {
  left: 80vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.4s infinite, 23.6s fall -4s infinite;
}
.snowflake._95 {
  left: 41vw;
  filter: blur(1px);
  animation: 3.7s flicker -0.6s infinite, 14s fall -12.4s infinite;
}
.snowflake._96 {
  left: -15vw;
  filter: blur(0px);
  animation: 3.1s flicker -1.9s infinite, 25.6s fall -1.4s infinite;
}
.snowflake._97 {
  left: 7vw;
  filter: blur(1px);
  animation: 3s flicker -0.6s infinite, 12.4s fall -13s infinite;
}
.snowflake._98 {
  left: 15vw;
  filter: blur(0px);
  animation: 2.5s flicker -0.5s infinite, 28.8s fall -4s infinite;
}
.snowflake._99 {
  left: 72vw;
  filter: blur(0px);
  animation: 4s flicker -1.5s infinite, 15.2s fall -7.4s infinite;
}
.snowflake._100 {
  left: -2vw;
  filter: blur(1px);
  animation: 2.9s flicker -2s infinite, 12s fall -20s infinite;
}
.snowflake._101 {
  left: 22vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.7s infinite, 11s fall -8s infinite;
}
.snowflake._102 {
  left: 63vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.3s infinite, 12.4s fall -6.2s infinite;
}
.snowflake._103 {
  left: 2vw;
  filter: blur(1px);
  animation: 4s flicker -1.6s infinite, 13.8s fall -0.4s infinite;
}
.snowflake._104 {
  left: 97vw;
  filter: blur(1px);
  animation: 3.6s flicker -1.1s infinite, 16.8s fall -5.8s infinite;
}
.snowflake._105 {
  left: 79vw;
  filter: blur(0px);
  animation: 3.3s flicker -0.7s infinite, 29.8s fall -8.2s infinite;
}
.snowflake._106 {
  left: -8vw;
  filter: blur(0px);
  animation: 2.2s flicker -1.2s infinite, 24.4s fall -18.2s infinite;
}
.snowflake._107 {
  left: 51vw;
  filter: blur(1px);
  animation: 2.9s flicker -1.6s infinite, 24.6s fall -12.2s infinite;
}
.snowflake._108 {
  left: 99vw;
  filter: blur(0px);
  animation: 4s flicker -0.8s infinite, 21.6s fall -3s infinite;
}
.snowflake._109 {
  left: 47vw;
  filter: blur(0px);
  animation: 2.7s flicker -1.1s infinite, 11s fall -11.8s infinite;
}
.snowflake._110 {
  left: 50vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.5s infinite, 28s fall -20s infinite;
}
.snowflake._111 {
  left: 47vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.9s infinite, 27.2s fall -11.4s infinite;
}
.snowflake._112 {
  left: 12vw;
  filter: blur(0px);
  animation: 3.7s flicker -1.7s infinite, 19.6s fall -19s infinite;
}
.snowflake._113 {
  left: 94vw;
  filter: blur(0px);
  animation: 2.8s flicker -1.7s infinite, 10.2s fall -0.8s infinite;
}
.snowflake._114 {
  left: -5vw;
  filter: blur(1px);
  animation: 2.4s flicker -1.8s infinite, 25.2s fall -6.6s infinite;
}
.snowflake._115 {
  left: 92vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.1s infinite, 18.8s fall -6.2s infinite;
}
.snowflake._116 {
  left: 53vw;
  filter: blur(1px);
  animation: 3.2s flicker -0.2s infinite, 26.6s fall -5.2s infinite;
}
.snowflake._117 {
  left: 69vw;
  filter: blur(0px);
  animation: 2.2s flicker -1.5s infinite, 17.8s fall -5.6s infinite;
}
.snowflake._118 {
  left: 29vw;
  filter: blur(1px);
  animation: 3.1s flicker -0.9s infinite, 16.2s fall -13.2s infinite;
}
.snowflake._119 {
  left: 18vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.4s infinite, 13s fall -14.6s infinite;
}
.snowflake._120 {
  left: 8vw;
  filter: blur(1px);
  animation: 2.5s flicker -0.3s infinite, 12s fall -3.2s infinite;
}
.snowflake._121 {
  left: 32vw;
  filter: blur(1px);
  animation: 2.3s flicker -2s infinite, 18.2s fall -4.8s infinite;
}
.snowflake._122 {
  left: 79vw;
  filter: blur(1px);
  animation: 3.1s flicker -0.3s infinite, 22s fall -9.6s infinite;
}
.snowflake._123 {
  left: 95vw;
  filter: blur(1px);
  animation: 2.6s flicker -1.3s infinite, 22.8s fall -16.6s infinite;
}
.snowflake._124 {
  left: 96vw;
  filter: blur(0px);
  animation: 2.2s flicker -0.9s infinite, 28.2s fall -15.6s infinite;
}
.snowflake._125 {
  left: 75vw;
  filter: blur(1px);
  animation: 2.7s flicker -2s infinite, 19.2s fall -4.2s infinite;
}
.snowflake._126 {
  left: -13vw;
  filter: blur(0px);
  animation: 2.2s flicker -0.2s infinite, 11.6s fall -19.4s infinite;
}
.snowflake._127 {
  left: 100vw;
  filter: blur(1px);
  animation: 2.2s flicker -1.1s infinite, 17.2s fall -2.6s infinite;
}
.snowflake._128 {
  left: 92vw;
  filter: blur(0px);
  animation: 3.4s flicker -0.7s infinite, 13.8s fall -3.4s infinite;
}
.snowflake._129 {
  left: 7vw;
  filter: blur(0px);
  animation: 3.6s flicker -1.9s infinite, 10.6s fall -6.6s infinite;
}
.snowflake._130 {
  left: 42vw;
  filter: blur(1px);
  animation: 2.6s flicker -0.5s infinite, 11s fall -1.2s infinite;
}
.snowflake._131 {
  left: 41vw;
  filter: blur(0px);
  animation: 2.5s flicker -1.4s infinite, 15.6s fall -17s infinite;
}
.snowflake._132 {
  left: 15vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.1s infinite, 12.8s fall -19.2s infinite;
}
.snowflake._133 {
  left: 82vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.7s infinite, 10.8s fall -12.4s infinite;
}
.snowflake._134 {
  left: 86vw;
  filter: blur(1px);
  animation: 3.2s flicker -1.8s infinite, 18.6s fall -15.8s infinite;
}
.snowflake._135 {
  left: 54vw;
  filter: blur(0px);
  animation: 3.2s flicker -0.5s infinite, 21.6s fall -17s infinite;
}
.snowflake._136 {
  left: 41vw;
  filter: blur(1px);
  animation: 2.3s flicker -1s infinite, 25.6s fall -2.6s infinite;
}
.snowflake._137 {
  left: 36vw;
  filter: blur(1px);
  animation: 2.3s flicker -0.1s infinite, 26.8s fall -18.2s infinite;
}
.snowflake._138 {
  left: 17vw;
  filter: blur(1px);
  animation: 3.3s flicker -1.6s infinite, 11s fall -5.2s infinite;
}
.snowflake._139 {
  left: 70vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.5s infinite, 10.8s fall -16.6s infinite;
}
.snowflake._140 {
  left: 20vw;
  filter: blur(1px);
  animation: 2.6s flicker -0.7s infinite, 22.6s fall -7.4s infinite;
}
.snowflake._141 {
  left: -6vw;
  filter: blur(0px);
  animation: 3.9s flicker -1.8s infinite, 29.4s fall -9.4s infinite;
}
.snowflake._142 {
  left: 2vw;
  filter: blur(1px);
  animation: 2.8s flicker -1.2s infinite, 19.2s fall -4.4s infinite;
}
.snowflake._143 {
  left: 16vw;
  filter: blur(0px);
  animation: 3.9s flicker -1.3s infinite, 13.4s fall -19.2s infinite;
}
.snowflake._144 {
  left: 100vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.6s infinite, 25.8s fall -15.8s infinite;
}
.snowflake._145 {
  left: 97vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.1s infinite, 25.2s fall -20s infinite;
}
.snowflake._146 {
  left: 95vw;
  filter: blur(1px);
  animation: 3.3s flicker -1s infinite, 14.4s fall -9s infinite;
}
.snowflake._147 {
  left: 42vw;
  filter: blur(1px);
  animation: 3.2s flicker -0.4s infinite, 16.8s fall -13.4s infinite;
}
.snowflake._148 {
  left: 65vw;
  filter: blur(0px);
  animation: 3.3s flicker -1.9s infinite, 24.4s fall -13.8s infinite;
}
.snowflake._149 {
  left: 15vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.5s infinite, 29.2s fall -11s infinite;
}
.snowflake._150 {
  left: 9vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.5s infinite, 27.4s fall -18.2s infinite;
}
.snowflake._151 {
  left: 72vw;
  filter: blur(1px);
  animation: 4s flicker -0.9s infinite, 13.6s fall -5.2s infinite;
}
.snowflake._152 {
  left: 75vw;
  filter: blur(1px);
  animation: 2.4s flicker -1.2s infinite, 25.8s fall -5.2s infinite;
}
.snowflake._153 {
  left: 20vw;
  filter: blur(0px);
  animation: 2.4s flicker -0.4s infinite, 12.8s fall -4.2s infinite;
}
.snowflake._154 {
  left: 43vw;
  filter: blur(1px);
  animation: 3.5s flicker -1.2s infinite, 28.8s fall -14.8s infinite;
}
.snowflake._155 {
  left: 29vw;
  filter: blur(0px);
  animation: 2.7s flicker -1.7s infinite, 14s fall -17.6s infinite;
}
.snowflake._156 {
  left: 69vw;
  filter: blur(0px);
  animation: 2.2s flicker -1.5s infinite, 28.8s fall -11.8s infinite;
}
.snowflake._157 {
  left: 78vw;
  filter: blur(0px);
  animation: 2.7s flicker -0.6s infinite, 27.6s fall -10.8s infinite;
}
.snowflake._158 {
  left: 63vw;
  filter: blur(1px);
  animation: 2.4s flicker -1.1s infinite, 22.6s fall -18s infinite;
}
.snowflake._159 {
  left: 76vw;
  filter: blur(0px);
  animation: 3.2s flicker -0.8s infinite, 27.4s fall -16.8s infinite;
}
.snowflake._160 {
  left: 49vw;
  filter: blur(0px);
  animation: 2.1s flicker -1.3s infinite, 12.2s fall -11.6s infinite;
}
.snowflake._161 {
  left: 94vw;
  filter: blur(0px);
  animation: 3.5s flicker -1.9s infinite, 28.6s fall -14.2s infinite;
}
.snowflake._162 {
  left: 62vw;
  filter: blur(1px);
  animation: 2.2s flicker -1.3s infinite, 22.6s fall -9.4s infinite;
}
.snowflake._163 {
  left: 1vw;
  filter: blur(0px);
  animation: 3.9s flicker -1.8s infinite, 21.2s fall -7.2s infinite;
}
.snowflake._164 {
  left: 7vw;
  filter: blur(1px);
  animation: 2.3s flicker -1.4s infinite, 24.4s fall -2.4s infinite;
}
.snowflake._165 {
  left: 49vw;
  filter: blur(0px);
  animation: 2.3s flicker -0.9s infinite, 20.8s fall -10.6s infinite;
}
.snowflake._166 {
  left: 83vw;
  filter: blur(1px);
  animation: 2.3s flicker -0.2s infinite, 26.4s fall -13.4s infinite;
}
.snowflake._167 {
  left: 97vw;
  filter: blur(1px);
  animation: 3.2s flicker -1s infinite, 28.2s fall -10.6s infinite;
}
.snowflake._168 {
  left: 0vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.6s infinite, 15.4s fall -12s infinite;
}
.snowflake._169 {
  left: 62vw;
  filter: blur(1px);
  animation: 3.6s flicker -1.6s infinite, 24.2s fall -1.8s infinite;
}
.snowflake._170 {
  left: 19vw;
  filter: blur(1px);
  animation: 2.5s flicker -1.3s infinite, 24s fall -11.6s infinite;
}
.snowflake._171 {
  left: 83vw;
  filter: blur(1px);
  animation: 3s flicker -0.5s infinite, 19.2s fall -13.4s infinite;
}
.snowflake._172 {
  left: 25vw;
  filter: blur(0px);
  animation: 3.4s flicker -1.2s infinite, 12.8s fall -9.4s infinite;
}
.snowflake._173 {
  left: 19vw;
  filter: blur(1px);
  animation: 3.4s flicker -1.9s infinite, 19.8s fall -11.6s infinite;
}
.snowflake._174 {
  left: 22vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.8s infinite, 25.6s fall -3.8s infinite;
}
.snowflake._175 {
  left: 65vw;
  filter: blur(0px);
  animation: 3s flicker -1s infinite, 12.8s fall -17.4s infinite;
}
.snowflake._176 {
  left: 10vw;
  filter: blur(1px);
  animation: 3.3s flicker -2s infinite, 29s fall -7.4s infinite;
}
.snowflake._177 {
  left: 67vw;
  filter: blur(1px);
  animation: 2.9s flicker -0.3s infinite, 24s fall -3.4s infinite;
}
.snowflake._178 {
  left: 91vw;
  filter: blur(0px);
  animation: 3.6s flicker -0.9s infinite, 23.2s fall -11.8s infinite;
}
.snowflake._179 {
  left: -5vw;
  filter: blur(1px);
  animation: 2.6s flicker -1.1s infinite, 14.2s fall -9.8s infinite;
}
.snowflake._180 {
  left: 22vw;
  filter: blur(1px);
  animation: 2.6s flicker -0.6s infinite, 21.2s fall -16.8s infinite;
}
.snowflake._181 {
  left: -14vw;
  filter: blur(1px);
  animation: 2.8s flicker -0.8s infinite, 12s fall -10.4s infinite;
}
.snowflake._182 {
  left: 71vw;
  filter: blur(0px);
  animation: 3.3s flicker -0.9s infinite, 19.8s fall -10s infinite;
}
.snowflake._183 {
  left: 0vw;
  filter: blur(0px);
  animation: 3.9s flicker -1.2s infinite, 28.4s fall -18.4s infinite;
}
.snowflake._184 {
  left: 41vw;
  filter: blur(0px);
  animation: 2.3s flicker -1.9s infinite, 14.6s fall -2.4s infinite;
}
.snowflake._185 {
  left: 68vw;
  filter: blur(1px);
  animation: 3.6s flicker -2s infinite, 23s fall -7.6s infinite;
}
.snowflake._186 {
  left: 38vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.3s infinite, 28.2s fall -7.8s infinite;
}
.snowflake._187 {
  left: 47vw;
  filter: blur(0px);
  animation: 2.7s flicker -0.2s infinite, 22.8s fall -7.4s infinite;
}
.snowflake._188 {
  left: 43vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.2s infinite, 13s fall -11.6s infinite;
}
.snowflake._189 {
  left: -6vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.2s infinite, 12.8s fall -7.6s infinite;
}
.snowflake._190 {
  left: 62vw;
  filter: blur(1px);
  animation: 3.2s flicker -1.4s infinite, 17s fall -16s infinite;
}
.snowflake._191 {
  left: 98vw;
  filter: blur(1px);
  animation: 2.8s flicker -1.9s infinite, 14.2s fall -6.2s infinite;
}
.snowflake._192 {
  left: 6vw;
  filter: blur(0px);
  animation: 3.4s flicker -0.2s infinite, 11.6s fall -5.4s infinite;
}
.snowflake._193 {
  left: -19vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.5s infinite, 11s fall -19.2s infinite;
}
.snowflake._194 {
  left: 1vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.3s infinite, 18s fall -2s infinite;
}
.snowflake._195 {
  left: 50vw;
  filter: blur(1px);
  animation: 4s flicker -1.4s infinite, 22.4s fall -7s infinite;
}
.snowflake._196 {
  left: -4vw;
  filter: blur(0px);
  animation: 3.2s flicker -2s infinite, 27.2s fall -11.4s infinite;
}
.snowflake._197 {
  left: -2vw;
  filter: blur(1px);
  animation: 2.1s flicker -0.3s infinite, 24s fall -17s infinite;
}
.snowflake._198 {
  left: 0vw;
  filter: blur(1px);
  animation: 2.8s flicker -0.6s infinite, 24s fall -10.8s infinite;
}
.snowflake._199 {
  left: 63vw;
  filter: blur(1px);
  animation: 3s flicker -0.5s infinite, 11s fall -3s infinite;
}
.snowflake._200 {
  left: 89vw;
  filter: blur(0px);
  animation: 2.6s flicker -1s infinite, 23.8s fall -0.4s infinite;
}
.snowflake._201 {
  left: 89vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.3s infinite, 29s fall -18.4s infinite;
}
.snowflake._202 {
  left: 93vw;
  filter: blur(1px);
  animation: 2.8s flicker -0.4s infinite, 28.2s fall -1.8s infinite;
}
.snowflake._203 {
  left: 48vw;
  filter: blur(0px);
  animation: 2.8s flicker -1.2s infinite, 11.2s fall -2.2s infinite;
}
.snowflake._204 {
  left: 30vw;
  filter: blur(0px);
  animation: 3.2s flicker -0.2s infinite, 29.6s fall -4.8s infinite;
}
.snowflake._205 {
  left: 28vw;
  filter: blur(1px);
  animation: 3.6s flicker -0.6s infinite, 23s fall -13.4s infinite;
}
.snowflake._206 {
  left: -11vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.4s infinite, 15.2s fall -3.4s infinite;
}
.snowflake._207 {
  left: 24vw;
  filter: blur(0px);
  animation: 4s flicker -0.3s infinite, 17.8s fall -14.8s infinite;
}
.snowflake._208 {
  left: 22vw;
  filter: blur(1px);
  animation: 2.1s flicker -1.3s infinite, 28.8s fall -4s infinite;
}
.snowflake._209 {
  left: 27vw;
  filter: blur(1px);
  animation: 3.1s flicker -0.7s infinite, 19.2s fall -4s infinite;
}
.snowflake._210 {
  left: 96vw;
  filter: blur(1px);
  animation: 3.2s flicker -1s infinite, 20s fall -14s infinite;
}
.snowflake._211 {
  left: 45vw;
  filter: blur(0px);
  animation: 3.3s flicker -0.4s infinite, 10.2s fall -17.2s infinite;
}
.snowflake._212 {
  left: 8vw;
  filter: blur(1px);
  animation: 2.3s flicker -0.6s infinite, 13.6s fall -16.2s infinite;
}
.snowflake._213 {
  left: 77vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.1s infinite, 15.4s fall -14.6s infinite;
}
.snowflake._214 {
  left: 36vw;
  filter: blur(1px);
  animation: 2.6s flicker -1.6s infinite, 20.4s fall -17.8s infinite;
}
.snowflake._215 {
  left: 46vw;
  filter: blur(0px);
  animation: 2.3s flicker -0.3s infinite, 22.6s fall -18s infinite;
}
.snowflake._216 {
  left: -7vw;
  filter: blur(0px);
  animation: 2.3s flicker -0.4s infinite, 20s fall -11.6s infinite;
}
.snowflake._217 {
  left: 19vw;
  filter: blur(1px);
  animation: 2.5s flicker -1.6s infinite, 25s fall -19.4s infinite;
}
.snowflake._218 {
  left: -15vw;
  filter: blur(0px);
  animation: 2.3s flicker -1s infinite, 21.6s fall -14s infinite;
}
.snowflake._219 {
  left: 90vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.7s infinite, 19.2s fall -20s infinite;
}
.snowflake._220 {
  left: 27vw;
  filter: blur(0px);
  animation: 3.7s flicker -1.9s infinite, 26s fall -16s infinite;
}
.snowflake._221 {
  left: -8vw;
  filter: blur(0px);
  animation: 2.8s flicker -0.3s infinite, 20s fall -18.6s infinite;
}
.snowflake._222 {
  left: 49vw;
  filter: blur(1px);
  animation: 3.4s flicker -0.5s infinite, 11.4s fall -18.8s infinite;
}
.snowflake._223 {
  left: 66vw;
  filter: blur(0px);
  animation: 3.4s flicker -0.6s infinite, 22.2s fall -2s infinite;
}
.snowflake._224 {
  left: 44vw;
  filter: blur(1px);
  animation: 2.7s flicker -0.1s infinite, 28.2s fall -3.6s infinite;
}
.snowflake._225 {
  left: 1vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.2s infinite, 20s fall -12.2s infinite;
}
.snowflake._226 {
  left: 3vw;
  filter: blur(1px);
  animation: 2.7s flicker -0.4s infinite, 14.2s fall -10.6s infinite;
}
.snowflake._227 {
  left: 90vw;
  filter: blur(0px);
  animation: 3.9s flicker -1.5s infinite, 17s fall -15.2s infinite;
}
.snowflake._228 {
  left: 89vw;
  filter: blur(1px);
  animation: 3s flicker -0.8s infinite, 11s fall -2.4s infinite;
}
.snowflake._229 {
  left: 98vw;
  filter: blur(0px);
  animation: 3.5s flicker -0.7s infinite, 15.8s fall -10.6s infinite;
}
.snowflake._230 {
  left: -2vw;
  filter: blur(0px);
  animation: 2.7s flicker -1.3s infinite, 24.4s fall -14.6s infinite;
}
.snowflake._231 {
  left: 40vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.9s infinite, 25.2s fall -10.6s infinite;
}
.snowflake._232 {
  left: 80vw;
  filter: blur(0px);
  animation: 2.5s flicker -1.1s infinite, 24.2s fall -1s infinite;
}
.snowflake._233 {
  left: 63vw;
  filter: blur(1px);
  animation: 3.8s flicker -2s infinite, 24.8s fall -4.2s infinite;
}
.snowflake._234 {
  left: 11vw;
  filter: blur(1px);
  animation: 2.1s flicker -0.9s infinite, 10.4s fall -15.4s infinite;
}
.snowflake._235 {
  left: 69vw;
  filter: blur(1px);
  animation: 2.1s flicker -1s infinite, 25.4s fall -8s infinite;
}
.snowflake._236 {
  left: 62vw;
  filter: blur(1px);
  animation: 2.3s flicker -0.8s infinite, 30s fall -6.4s infinite;
}
.snowflake._237 {
  left: 58vw;
  filter: blur(1px);
  animation: 3.9s flicker -0.1s infinite, 26.6s fall -0.4s infinite;
}
.snowflake._238 {
  left: 52vw;
  filter: blur(0px);
  animation: 3.9s flicker -0.2s infinite, 22.2s fall -1.6s infinite;
}
.snowflake._239 {
  left: 16vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.1s infinite, 24s fall -12.4s infinite;
}
.snowflake._240 {
  left: 71vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.9s infinite, 10.4s fall -18.2s infinite;
}
.snowflake._241 {
  left: -15vw;
  filter: blur(1px);
  animation: 2.4s flicker -1.7s infinite, 16.4s fall -14.8s infinite;
}
.snowflake._242 {
  left: 26vw;
  filter: blur(0px);
  animation: 2.1s flicker -2s infinite, 21.4s fall -15.4s infinite;
}
.snowflake._243 {
  left: 40vw;
  filter: blur(1px);
  animation: 2.7s flicker -0.8s infinite, 21.8s fall -10.6s infinite;
}
.snowflake._244 {
  left: 91vw;
  filter: blur(1px);
  animation: 3.3s flicker -0.5s infinite, 26.8s fall -12s infinite;
}
.snowflake._245 {
  left: 52vw;
  filter: blur(0px);
  animation: 2.5s flicker -1.9s infinite, 10.6s fall -2s infinite;
}
.snowflake._246 {
  left: -18vw;
  filter: blur(1px);
  animation: 2.8s flicker -1.1s infinite, 29.2s fall -3.2s infinite;
}
.snowflake._247 {
  left: 94vw;
  filter: blur(0px);
  animation: 3.3s flicker -0.5s infinite, 29.8s fall -3s infinite;
}
.snowflake._248 {
  left: 1vw;
  filter: blur(1px);
  animation: 2.9s flicker -0.8s infinite, 11.4s fall -10.4s infinite;
}
.snowflake._249 {
  left: -16vw;
  filter: blur(0px);
  animation: 3.6s flicker -0.5s infinite, 20.8s fall -17.2s infinite;
}
.snowflake._250 {
  left: 24vw;
  filter: blur(0px);
  animation: 3.8s flicker -1.5s infinite, 18.4s fall -3s infinite;
}
.snowflake._md-1 {
  left: 96vw;
  filter: blur(0px);
  animation: 2.5s flicker -0.4s infinite, 16.8s fall -3.2s infinite;
}
.snowflake._md-2 {
  left: 19vw;
  filter: blur(0px);
  animation: 2.4s flicker -0.3s infinite, 29.2s fall -17.8s infinite;
}
.snowflake._md-3 {
  left: -3vw;
  filter: blur(0px);
  animation: 2.9s flicker -0.9s infinite, 14.2s fall -7.4s infinite;
}
.snowflake._md-4 {
  left: 43vw;
  filter: blur(1px);
  animation: 2.7s flicker -0.4s infinite, 27.8s fall -17.4s infinite;
}
.snowflake._md-5 {
  left: 58vw;
  filter: blur(0px);
  animation: 2.5s flicker -0.1s infinite, 21s fall -12.4s infinite;
}
.snowflake._md-6 {
  left: 86vw;
  filter: blur(0px);
  animation: 3.2s flicker -1.9s infinite, 30s fall -10.6s infinite;
}
.snowflake._md-7 {
  left: 78vw;
  filter: blur(0px);
  animation: 2.8s flicker -1.5s infinite, 15s fall -4.4s infinite;
}
.snowflake._md-8 {
  left: 32vw;
  filter: blur(0px);
  animation: 2.2s flicker -0.3s infinite, 18.8s fall -15.8s infinite;
}
.snowflake._md-9 {
  left: 62vw;
  filter: blur(1px);
  animation: 3.3s flicker -0.6s infinite, 19.8s fall -19.6s infinite;
}
.snowflake._md-10 {
  left: 12vw;
  filter: blur(0px);
  animation: 3.6s flicker -1s infinite, 13.8s fall -9.6s infinite;
}
.snowflake._md-11 {
  left: 75vw;
  filter: blur(1px);
  animation: 4s flicker -1.7s infinite, 27.6s fall -7s infinite;
}
.snowflake._md-12 {
  left: -5vw;
  filter: blur(0px);
  animation: 3.3s flicker -0.3s infinite, 27.8s fall -10.8s infinite;
}
.snowflake._md-13 {
  left: 18vw;
  filter: blur(0px);
  animation: 3.8s flicker -0.3s infinite, 29.8s fall -19s infinite;
}
.snowflake._md-14 {
  left: 87vw;
  filter: blur(1px);
  animation: 2.9s flicker -1.5s infinite, 14s fall -9.2s infinite;
}
.snowflake._md-15 {
  left: -19vw;
  filter: blur(0px);
  animation: 3s flicker -0.4s infinite, 26.8s fall -13s infinite;
}
.snowflake._md-16 {
  left: -18vw;
  filter: blur(1px);
  animation: 2.7s flicker -1.5s infinite, 21.4s fall -2.8s infinite;
}
.snowflake._md-17 {
  left: 81vw;
  filter: blur(1px);
  animation: 2.4s flicker -1.9s infinite, 24.2s fall -12s infinite;
}
.snowflake._md-18 {
  left: 50vw;
  filter: blur(1px);
  animation: 2.5s flicker -0.5s infinite, 15.6s fall -13.4s infinite;
}
.snowflake._md-19 {
  left: 96vw;
  filter: blur(0px);
  animation: 2.6s flicker -0.4s infinite, 10.4s fall -9.6s infinite;
}
.snowflake._md-20 {
  left: 52vw;
  filter: blur(0px);
  animation: 3.5s flicker -0.3s infinite, 22.2s fall -13s infinite;
}
.snowflake._md-21 {
  left: 1vw;
  filter: blur(0px);
  animation: 2.9s flicker -1s infinite, 23s fall -11.6s infinite;
}
.snowflake._md-22 {
  left: 10vw;
  filter: blur(1px);
  animation: 2.6s flicker -1.3s infinite, 24.4s fall -11s infinite;
}
.snowflake._md-23 {
  left: 75vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.1s infinite, 21.2s fall -14s infinite;
}
.snowflake._md-24 {
  left: 83vw;
  filter: blur(0px);
  animation: 3.3s flicker -1.8s infinite, 25.6s fall -15.6s infinite;
}
.snowflake._md-25 {
  left: 98vw;
  filter: blur(0px);
  animation: 2.1s flicker -0.3s infinite, 25.4s fall -18.8s infinite;
}
.snowflake._md-26 {
  left: 16vw;
  filter: blur(0px);
  animation: 2.9s flicker -1.6s infinite, 17.6s fall -1.4s infinite;
}
.snowflake._md-27 {
  left: 62vw;
  filter: blur(1px);
  animation: 3.3s flicker -0.4s infinite, 21.6s fall -20s infinite;
}
.snowflake._md-28 {
  left: 6vw;
  filter: blur(1px);
  animation: 2.6s flicker -0.6s infinite, 13.4s fall -17s infinite;
}
.snowflake._md-29 {
  left: 48vw;
  filter: blur(1px);
  animation: 2.6s flicker -1.5s infinite, 30s fall -16.8s infinite;
}
.snowflake._md-30 {
  left: 18vw;
  filter: blur(0px);
  animation: 2.8s flicker -0.2s infinite, 17.4s fall -17.8s infinite;
}
.snowflake._md-31 {
  left: 97vw;
  filter: blur(0px);
  animation: 2.5s flicker -0.6s infinite, 28.8s fall -7.4s infinite;
}
.snowflake._md-32 {
  left: 2vw;
  filter: blur(0px);
  animation: 2.7s flicker -0.4s infinite, 21.2s fall -4.8s infinite;
}
.snowflake._md-33 {
  left: 56vw;
  filter: blur(1px);
  animation: 2.4s flicker -1s infinite, 27.6s fall -17.2s infinite;
}
.snowflake._md-34 {
  left: 50vw;
  filter: blur(0px);
  animation: 3.5s flicker -0.3s infinite, 13.2s fall -19.8s infinite;
}
.snowflake._md-35 {
  left: 50vw;
  filter: blur(1px);
  animation: 2.5s flicker -0.7s infinite, 26.8s fall -15s infinite;
}
.snowflake._md-36 {
  left: 99vw;
  filter: blur(1px);
  animation: 2.2s flicker -0.3s infinite, 17.2s fall -0.8s infinite;
}
.snowflake._md-37 {
  left: 36vw;
  filter: blur(1px);
  animation: 3s flicker -1.3s infinite, 12s fall -5.4s infinite;
}
.snowflake._md-38 {
  left: 75vw;
  filter: blur(0px);
  animation: 2.8s flicker -1.4s infinite, 27.8s fall -10.4s infinite;
}
.snowflake._md-39 {
  left: -3vw;
  filter: blur(0px);
  animation: 2.1s flicker -1.9s infinite, 21.6s fall -14.2s infinite;
}
.snowflake._md-40 {
  left: 49vw;
  filter: blur(1px);
  animation: 2.3s flicker -1.2s infinite, 27.6s fall -17.8s infinite;
}
.snowflake._md-41 {
  left: -7vw;
  filter: blur(1px);
  animation: 3.3s flicker -1.4s infinite, 13.6s fall -7.2s infinite;
}
.snowflake._md-42 {
  left: 18vw;
  filter: blur(1px);
  animation: 3.1s flicker -1.6s infinite, 10.6s fall -4.4s infinite;
}
.snowflake._md-43 {
  left: 46vw;
  filter: blur(1px);
  animation: 2.2s flicker -1.1s infinite, 22.4s fall -5.6s infinite;
}
.snowflake._md-44 {
  left: -11vw;
  filter: blur(0px);
  animation: 3.7s flicker -1s infinite, 20.8s fall -13s infinite;
}
.snowflake._md-45 {
  left: 45vw;
  filter: blur(1px);
  animation: 2.4s flicker -0.9s infinite, 23.2s fall -16.4s infinite;
}
.snowflake._md-46 {
  left: 67vw;
  filter: blur(0px);
  animation: 3.1s flicker -2s infinite, 25.4s fall -17.4s infinite;
}
.snowflake._md-47 {
  left: 7vw;
  filter: blur(0px);
  animation: 3s flicker -0.8s infinite, 28.2s fall -20s infinite;
}
.snowflake._md-48 {
  left: 91vw;
  filter: blur(0px);
  animation: 3.8s flicker -1.9s infinite, 19.6s fall -2s infinite;
}
.snowflake._md-49 {
  left: 36vw;
  filter: blur(1px);
  animation: 3.8s flicker -1.9s infinite, 30s fall -15.6s infinite;
}
.snowflake._md-50 {
  left: 51vw;
  filter: blur(1px);
  animation: 3s flicker -1.2s infinite, 28.2s fall -8.8s infinite;
}
.snowflake._lg-1 {
  left: 9vw;
  animation: 3.3s flicker -1.8s infinite, 17.4s fall -14.6s infinite;
}
.snowflake._lg-2 {
  left: 64vw;
  animation: 2.5s flicker -0.9s infinite, 15.8s fall -4.4s infinite;
}
.snowflake._lg-3 {
  left: 44vw;
  animation: 2.2s flicker -1.2s infinite, 14.4s fall -3.6s infinite;
}
.snowflake._lg-4 {
  left: 13vw;
  animation: 2.8s flicker -0.9s infinite, 21s fall -3.6s infinite;
}
.snowflake._lg-5 {
  left: 2vw;
  animation: 2.8s flicker -1.7s infinite, 26s fall -2.6s infinite;
}
.snowflake._lg-6 {
  left: 56vw;
  animation: 2.6s flicker -0.5s infinite, 23.6s fall -12.6s infinite;
}
.snowflake._lg-7 {
  left: -19vw;
  animation: 3.1s flicker -0.5s infinite, 21.6s fall -3.6s infinite;
}
.snowflake._lg-8 {
  left: 52vw;
  animation: 3.9s flicker -0.5s infinite, 25.6s fall -8s infinite;
}
.snowflake._lg-9 {
  left: 41vw;
  animation: 3.6s flicker -0.5s infinite, 13.2s fall -4s infinite;
}
.snowflake._lg-10 {
  left: -8vw;
  animation: 2.6s flicker -0.9s infinite, 19.8s fall -14.8s infinite;
}
.snowflake._lg-11 {
  left: 71vw;
  animation: 3.8s flicker -0.1s infinite, 27.8s fall -10.4s infinite;
}
.snowflake._lg-12 {
  left: 62vw;
  animation: 3.1s flicker -0.6s infinite, 24.8s fall -14s infinite;
}
.snowflake._lg-13 {
  left: 40vw;
  animation: 3.7s flicker -0.7s infinite, 28.8s fall -19.6s infinite;
}
.snowflake._lg-14 {
  left: 15vw;
  animation: 3.8s flicker -0.3s infinite, 26s fall -10.4s infinite;
}
.snowflake._lg-15 {
  left: -9vw;
  animation: 4s flicker -1.7s infinite, 25.6s fall -7.2s infinite;
}
.snowflake._lg-16 {
  left: 99vw;
  animation: 2.9s flicker -1.1s infinite, 11s fall -6.4s infinite;
}
.snowflake._lg-17 {
  left: 92vw;
  animation: 2.9s flicker -0.3s infinite, 28.6s fall -6.2s infinite;
}
.snowflake._lg-18 {
  left: 84vw;
  animation: 2.9s flicker -0.7s infinite, 17.4s fall -4.8s infinite;
}
.snowflake._lg-19 {
  left: 100vw;
  animation: 4s flicker -0.7s infinite, 13.8s fall -19s infinite;
}
.snowflake._lg-20 {
  left: 75vw;
  animation: 3.3s flicker -1.1s infinite, 18.6s fall -19.8s infinite;
}
.snowflake._lg-21 {
  left: 69vw;
  animation: 3s flicker -0.5s infinite, 15.2s fall -16.8s infinite;
}
.snowflake._lg-22 {
  left: -7vw;
  animation: 3.1s flicker -1.6s infinite, 24.4s fall -8.2s infinite;
}
.snowflake._lg-23 {
  left: 46vw;
  animation: 4s flicker -1.9s infinite, 28.2s fall -16.2s infinite;
}
.snowflake._lg-24 {
  left: 26vw;
  animation: 3.7s flicker -0.2s infinite, 20.6s fall -2s infinite;
}
.snowflake._lg-25 {
  left: 41vw;
  animation: 3.8s flicker -1.4s infinite, 25.4s fall -19s infinite;
}
.snowflake._lg-26 {
  left: 13vw;
  animation: 3.5s flicker -0.3s infinite, 26.4s fall -8.2s infinite;
}
.snowflake._lg-27 {
  left: 57vw;
  animation: 3.9s flicker -1.3s infinite, 16.4s fall -17.8s infinite;
}
.snowflake._lg-28 {
  left: 5vw;
  animation: 2.7s flicker -1.6s infinite, 10.2s fall -10.6s infinite;
}
.snowflake._lg-29 {
  left: -12vw;
  animation: 3.5s flicker -0.3s infinite, 11.4s fall -15.8s infinite;
}
.snowflake._lg-30 {
  left: 67vw;
  animation: 2.6s flicker -1.3s infinite, 17.4s fall -16.2s infinite;
}
.snowflake._lg-31 {
  left: -9vw;
  animation: 4s flicker -0.3s infinite, 18.2s fall -9.6s infinite;
}
.snowflake._lg-32 {
  left: 9vw;
  animation: 3.4s flicker -1.8s infinite, 25.8s fall -12.4s infinite;
}
.snowflake._lg-33 {
  left: 88vw;
  animation: 2.1s flicker -0.1s infinite, 22.2s fall -9.8s infinite;
}
.snowflake._lg-34 {
  left: 33vw;
  animation: 2.7s flicker -1.8s infinite, 11.8s fall -13.4s infinite;
}
.snowflake._lg-35 {
  left: 39vw;
  animation: 3.9s flicker -0.2s infinite, 26s fall -13s infinite;
}
.snowflake._lg-36 {
  left: 31vw;
  animation: 3.3s flicker -1.6s infinite, 16.2s fall -7.6s infinite;
}
.snowflake._lg-37 {
  left: 29vw;
  animation: 3.7s flicker -0.5s infinite, 28s fall -18.8s infinite;
}
.snowflake._lg-38 {
  left: 1vw;
  animation: 3.1s flicker -1.1s infinite, 19.8s fall -17s infinite;
}
.snowflake._lg-39 {
  left: 21vw;
  animation: 2.3s flicker -2s infinite, 28.4s fall -0.6s infinite;
}
.snowflake._lg-40 {
  left: 20vw;
  animation: 3.8s flicker -0.6s infinite, 26.4s fall -1.2s infinite;
}
.snowflake._lg-41 {
  left: 97vw;
  animation: 3.4s flicker -1.7s infinite, 21.2s fall -15.6s infinite;
}
.snowflake._lg-42 {
  left: 6vw;
  animation: 3.8s flicker -0.7s infinite, 11.2s fall -1.6s infinite;
}
.snowflake._lg-43 {
  left: 34vw;
  animation: 2.9s flicker -0.6s infinite, 21.8s fall -19s infinite;
}
.snowflake._lg-44 {
  left: 94vw;
  animation: 3s flicker -1.4s infinite, 20.4s fall -17.8s infinite;
}
.snowflake._lg-45 {
  left: -17vw;
  animation: 2.7s flicker -1.3s infinite, 17s fall -13s infinite;
}
.snowflake._lg-46 {
  left: -6vw;
  animation: 3.4s flicker -1.6s infinite, 13.2s fall -18.2s infinite;
}
.snowflake._lg-47 {
  left: 3vw;
  animation: 3.4s flicker -2s infinite, 13.2s fall -5.2s infinite;
}
.snowflake._lg-48 {
  left: 42vw;
  animation: 3.2s flicker -1.8s infinite, 30s fall -13.6s infinite;
}
.snowflake._lg-49 {
  left: 18vw;
  animation: 3.4s flicker -2s infinite, 16s fall -4.2s infinite;
}
.snowflake._lg-50 {
  left: 25vw;
  animation: 3.2s flicker -0.3s infinite, 15s fall -18.8s infinite;
}

@keyframes flicker {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
}
@keyframes fall {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    transform: translate(20vw, 110vh) rotate(360deg);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/snowflake-area/snowflake-area.styles.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAHF;AAKE;EACE,uCAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;AAJF;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AASI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AARR;AAII;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAHR;AADI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAER;AANI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAOR;AAXI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAYR;AAhBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAiBR;AArBI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAsBR;AA1BI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AA2BR;AA/BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAgCR;AApCI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAqCR;AAzCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA0CR;AA9CI;EACE,SAAA;EACA,iBAAA;EACA,8DACE;AA+CR;AAnDI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAoDR;AAxDI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAyDR;AA7DI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA8DR;AAlEI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAmER;AAvEI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAwER;AA5EI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA6ER;AAjFI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAkFR;AAtFI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAuFR;AA3FI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA4FR;AAhGI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAiGR;AArGI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAsGR;AA1GI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AA2GR;AA/GI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAgHR;AApHI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAqHR;AAzHI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA0HR;AA9HI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA+HR;AAnII;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAoIR;AAxII;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAyIR;AA7II;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA8IR;AAlJI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAmJR;AAvJI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAwJR;AA5JI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6JR;AAjKI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AAkKR;AAtKI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAuKR;AA3KI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4KR;AAhLI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAiLR;AArLI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAsLR;AA1LI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA2LR;AA/LI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAgMR;AApMI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqMR;AAzMI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA0MR;AA9MI;EACE,SAAA;EACA,iBAAA;EACA,6DACE;AA+MR;AAnNI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAoNR;AAxNI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAyNR;AA7NI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA8NR;AAlOI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAmOR;AAvOI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAwOR;AA5OI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6OR;AAjPI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAkPR;AAtPI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAuPR;AA3PI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA4PR;AAhQI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAiQR;AArQI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAsQR;AA1QI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA2QR;AA/QI;EACE,WAAA;EACA,iBAAA;EACA,+DACE;AAgRR;AApRI;EACE,WAAA;EACA,iBAAA;EACA,kEACE;AAqRR;AAzRI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA0RR;AA9RI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA+RR;AAnSI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAoSR;AAxSI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAySR;AA7SI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA8SR;AAlTI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAmTR;AAvTI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAwTR;AA5TI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6TR;AAjUI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAkUR;AAtUI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AAuUR;AA3UI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4UR;AAhVI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAiVR;AArVI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAsVR;AA1VI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA2VR;AA/VI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAgWR;AApWI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAqWR;AAzWI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA0WR;AA9WI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AA+WR;AAnXI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAoXR;AAxXI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAyXR;AA7XI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA8XR;AAlYI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAmYR;AAvYI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAwYR;AA5YI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA6YR;AAjZI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAkZR;AAtZI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAuZR;AA3ZI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA4ZR;AAhaI;EACE,WAAA;EACA,iBAAA;EACA,+DACE;AAiaR;AAraI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAsaR;AA1aI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA2aR;AA/aI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAgbR;AApbI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAqbR;AAzbI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AA0bR;AA9bI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA+bR;AAncI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAocR;AAxcI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAycR;AA7cI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA8cR;AAldI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAmdR;AAvdI;EACE,SAAA;EACA,iBAAA;EACA,8DACE;AAwdR;AA5dI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6dR;AAjeI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAkeR;AAteI;EACE,UAAA;EACA,iBAAA;EACA,4DACE;AAueR;AA3eI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AA4eR;AAhfI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAifR;AArfI;EACE,SAAA;EACA,iBAAA;EACA,+DACE;AAsfR;AA1fI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA2fR;AA/fI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAggBR;AApgBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqgBR;AAzgBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA0gBR;AA9gBI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AA+gBR;AAnhBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAohBR;AAxhBI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAyhBR;AA7hBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA8hBR;AAliBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAmiBR;AAviBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAwiBR;AA5iBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA6iBR;AAjjBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAkjBR;AAtjBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAujBR;AA3jBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA4jBR;AAhkBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAikBR;AArkBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAskBR;AA1kBI;EACE,SAAA;EACA,iBAAA;EACA,+DACE;AA2kBR;AA/kBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAglBR;AAplBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAqlBR;AAzlBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA0lBR;AA9lBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA+lBR;AAnmBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAomBR;AAxmBI;EACE,WAAA;EACA,iBAAA;EACA,kEACE;AAymBR;AA7mBI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AA8mBR;AAlnBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAmnBR;AAvnBI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AAwnBR;AA5nBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6nBR;AAjoBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAkoBR;AAtoBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAuoBR;AA3oBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4oBR;AAhpBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAipBR;AArpBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAspBR;AA1pBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA2pBR;AA/pBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAgqBR;AApqBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAqqBR;AAzqBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA0qBR;AA9qBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA+qBR;AAnrBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAorBR;AAxrBI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AAyrBR;AA7rBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA8rBR;AAlsBI;EACE,WAAA;EACA,iBAAA;EACA,kEACE;AAmsBR;AAvsBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAwsBR;AA5sBI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AA6sBR;AAjtBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAktBR;AAttBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAutBR;AA3tBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA4tBR;AAhuBI;EACE,SAAA;EACA,iBAAA;EACA,kEACE;AAiuBR;AAruBI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAsuBR;AA1uBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA2uBR;AA/uBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAgvBR;AApvBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqvBR;AAzvBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA0vBR;AA9vBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA+vBR;AAnwBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAowBR;AAxwBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAywBR;AA7wBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA8wBR;AAlxBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAmxBR;AAvxBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAwxBR;AA5xBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA6xBR;AAjyBI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AAkyBR;AAtyBI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AAuyBR;AA3yBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4yBR;AAhzBI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAizBR;AArzBI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAszBR;AA1zBI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AA2zBR;AA/zBI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAg0BR;AAp0BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAq0BR;AAz0BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA00BR;AA90BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA+0BR;AAn1BI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAo1BR;AAx1BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAy1BR;AA71BI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AA81BR;AAl2BI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAm2BR;AAv2BI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAw2BR;AA52BI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA62BR;AAj3BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAk3BR;AAt3BI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAu3BR;AA33BI;EACE,WAAA;EACA,iBAAA;EACA,gEACE;AA43BR;AAh4BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAi4BR;AAr4BI;EACE,SAAA;EACA,iBAAA;EACA,kEACE;AAs4BR;AA14BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA24BR;AA/4BI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAg5BR;AAp5BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAq5BR;AAz5BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA05BR;AA95BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA+5BR;AAn6BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAo6BR;AAx6BI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AAy6BR;AA76BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA86BR;AAl7BI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AAm7BR;AAv7BI;EACE,WAAA;EACA,iBAAA;EACA,gEACE;AAw7BR;AA57BI;EACE,SAAA;EACA,iBAAA;EACA,6DACE;AA67BR;AAj8BI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAk8BR;AAt8BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAu8BR;AA38BI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AA48BR;AAh9BI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AAi9BR;AAr9BI;EACE,UAAA;EACA,iBAAA;EACA,2DACE;AAs9BR;AA19BI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA29BR;AA/9BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAg+BR;AAp+BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAq+BR;AAz+BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA0+BR;AA9+BI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA++BR;AAn/BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAo/BR;AAx/BI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAy/BR;AA7/BI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA8/BR;AAlgCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAmgCR;AAvgCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAwgCR;AA5gCI;EACE,UAAA;EACA,iBAAA;EACA,4DACE;AA6gCR;AAjhCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAkhCR;AAthCI;EACE,SAAA;EACA,iBAAA;EACA,kEACE;AAuhCR;AA3hCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4hCR;AAhiCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAiiCR;AAriCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAsiCR;AA1iCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA2iCR;AA/iCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAgjCR;AApjCI;EACE,WAAA;EACA,iBAAA;EACA,8DACE;AAqjCR;AAzjCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA0jCR;AA9jCI;EACE,UAAA;EACA,iBAAA;EACA,8DACE;AA+jCR;AAnkCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAokCR;AAxkCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAykCR;AA7kCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA8kCR;AAllCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAmlCR;AAvlCI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AAwlCR;AA5lCI;EACE,SAAA;EACA,iBAAA;EACA,kEACE;AA6lCR;AAjmCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAkmCR;AAtmCI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAumCR;AA3mCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA4mCR;AAhnCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAinCR;AArnCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAsnCR;AA1nCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA2nCR;AA/nCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAgoCR;AApoCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqoCR;AAzoCI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AA0oCR;AA9oCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA+oCR;AAnpCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAopCR;AAxpCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAypCR;AA7pCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA8pCR;AAlqCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAmqCR;AAvqCI;EACE,WAAA;EACA,iBAAA;EACA,kEACE;AAwqCR;AA5qCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA6qCR;AAjrCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAkrCR;AAtrCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAurCR;AA3rCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA4rCR;AAhsCI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AAisCR;AArsCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAssCR;AA1sCI;EACE,SAAA;EACA,iBAAA;EACA,kEACE;AA2sCR;AA/sCI;EACE,WAAA;EACA,iBAAA;EACA,kEACE;AAgtCR;AAptCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAqtCR;AA/sCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAgtCR;AAptCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqtCR;AAztCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA0tCR;AA9tCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA+tCR;AAnuCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAouCR;AAxuCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAyuCR;AA7uCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA8uCR;AAlvCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAmvCR;AAvvCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAwvCR;AA5vCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA6vCR;AAjwCI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAkwCR;AAtwCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAuwCR;AA3wCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA4wCR;AAhxCI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAixCR;AArxCI;EACE,WAAA;EACA,iBAAA;EACA,8DACE;AAsxCR;AA1xCI;EACE,WAAA;EACA,iBAAA;EACA,iEACE;AA2xCR;AA/xCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAgyCR;AApyCI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAqyCR;AAzyCI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA0yCR;AA9yCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA+yCR;AAnzCI;EACE,SAAA;EACA,iBAAA;EACA,8DACE;AAozCR;AAxzCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAyzCR;AA7zCI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA8zCR;AAl0CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAm0CR;AAv0CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAw0CR;AA50CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA60CR;AAj1CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAk1CR;AAt1CI;EACE,SAAA;EACA,iBAAA;EACA,gEACE;AAu1CR;AA31CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA41CR;AAh2CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAi2CR;AAr2CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAs2CR;AA12CI;EACE,SAAA;EACA,iBAAA;EACA,iEACE;AA22CR;AA/2CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAg3CR;AAp3CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAq3CR;AAz3CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AA03CR;AA93CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA+3CR;AAn4CI;EACE,UAAA;EACA,iBAAA;EACA,6DACE;AAo4CR;AAx4CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAy4CR;AA74CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA84CR;AAl5CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AAm5CR;AAv5CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAw5CR;AA55CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AA65CR;AAj6CI;EACE,UAAA;EACA,iBAAA;EACA,iEACE;AAk6CR;AAt6CI;EACE,WAAA;EACA,iBAAA;EACA,8DACE;AAu6CR;AA36CI;EACE,UAAA;EACA,iBAAA;EACA,kEACE;AA46CR;AAh7CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAi7CR;AAr7CI;EACE,SAAA;EACA,iBAAA;EACA,8DACE;AAs7CR;AA17CI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AA27CR;AA/7CI;EACE,UAAA;EACA,iBAAA;EACA,gEACE;AAg8CR;AAp8CI;EACE,UAAA;EACA,iBAAA;EACA,+DACE;AAq8CR;AA/7CI;EACE,SAAA;EACA,kEACE;AAg8CR;AAn8CI;EACE,UAAA;EACA,iEACE;AAo8CR;AAv8CI;EACE,UAAA;EACA,iEACE;AAw8CR;AA38CI;EACE,UAAA;EACA,+DACE;AA48CR;AA/8CI;EACE,SAAA;EACA,+DACE;AAg9CR;AAn9CI;EACE,UAAA;EACA,kEACE;AAo9CR;AAv9CI;EACE,WAAA;EACA,iEACE;AAw9CR;AA39CI;EACE,UAAA;EACA,+DACE;AA49CR;AA/9CI;EACE,UAAA;EACA,+DACE;AAg+CR;AAn+CI;EACE,UAAA;EACA,kEACE;AAo+CR;AAv+CI;EACE,UAAA;EACA,kEACE;AAw+CR;AA3+CI;EACE,UAAA;EACA,gEACE;AA4+CR;AA/+CI;EACE,UAAA;EACA,kEACE;AAg/CR;AAn/CI;EACE,UAAA;EACA,gEACE;AAo/CR;AAv/CI;EACE,UAAA;EACA,+DACE;AAw/CR;AA3/CI;EACE,UAAA;EACA,+DACE;AA4/CR;AA//CI;EACE,UAAA;EACA,iEACE;AAggDR;AAngDI;EACE,UAAA;EACA,iEACE;AAogDR;AAvgDI;EACE,WAAA;EACA,8DACE;AAwgDR;AA3gDI;EACE,UAAA;EACA,kEACE;AA4gDR;AA/gDI;EACE,UAAA;EACA,gEACE;AAghDR;AAnhDI;EACE,UAAA;EACA,iEACE;AAohDR;AAvhDI;EACE,UAAA;EACA,gEACE;AAwhDR;AA3hDI;EACE,UAAA;EACA,+DACE;AA4hDR;AA/hDI;EACE,UAAA;EACA,gEACE;AAgiDR;AAniDI;EACE,UAAA;EACA,iEACE;AAoiDR;AAviDI;EACE,UAAA;EACA,kEACE;AAwiDR;AA3iDI;EACE,SAAA;EACA,kEACE;AA4iDR;AA/iDI;EACE,WAAA;EACA,kEACE;AAgjDR;AAnjDI;EACE,UAAA;EACA,kEACE;AAojDR;AAvjDI;EACE,UAAA;EACA,+DACE;AAwjDR;AA3jDI;EACE,SAAA;EACA,kEACE;AA4jDR;AA/jDI;EACE,UAAA;EACA,iEACE;AAgkDR;AAnkDI;EACE,UAAA;EACA,kEACE;AAokDR;AAvkDI;EACE,UAAA;EACA,8DACE;AAwkDR;AA3kDI;EACE,UAAA;EACA,iEACE;AA4kDR;AA/kDI;EACE,UAAA;EACA,gEACE;AAglDR;AAnlDI;EACE,SAAA;EACA,gEACE;AAolDR;AAvlDI;EACE,UAAA;EACA,+DACE;AAwlDR;AA3lDI;EACE,UAAA;EACA,iEACE;AA4lDR;AA/lDI;EACE,UAAA;EACA,kEACE;AAgmDR;AAnmDI;EACE,SAAA;EACA,iEACE;AAomDR;AAvmDI;EACE,UAAA;EACA,gEACE;AAwmDR;AA3mDI;EACE,UAAA;EACA,gEACE;AA4mDR;AA/mDI;EACE,WAAA;EACA,8DACE;AAgnDR;AAnnDI;EACE,UAAA;EACA,kEACE;AAonDR;AAvnDI;EACE,SAAA;EACA,+DACE;AAwnDR;AA3nDI;EACE,UAAA;EACA,gEACE;AA4nDR;AA/nDI;EACE,UAAA;EACA,6DACE;AAgoDR;AAnoDI;EACE,UAAA;EACA,gEACE;AAooDR;;AA9nDA;EACE;IAEE,UAAA;EAgoDF;EA9nDA;IACE,YAAA;EAgoDF;AACF;AA7nDA;EACE;IACE,uCAAA;EA+nDF;EA7nDA;IACE,gDAAA;EA+nDF;AACF;AA5nDA;EACE;IACE,UAAA;EA8nDF;EA5nDA;IACE,UAAA;EA8nDF;AACF","sourcesContent":["$numberOfSnowflake: 250; // update together with component props\n$numberOfSnowflakeMd: 50; // update together with component props\n$numberOfSnowflakeLg: 50; // update together with component props\n\n.snowflake-area {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  &--fading-out {\n    animation: fadeOut 1s ease-out forwards;\n  }\n}\n\n.snowflake {\n  position: absolute;\n  top: -2vh;\n  font-size: 10px;\n  animation: fall linear infinite;\n  opacity: 0.8;\n\n  &._md {\n    font-size: 1.5em;\n  }\n\n  &._lg {\n    font-size: 2.25em;\n  }\n\n  @for $i from 1 through $numberOfSnowflake {\n    &._#{$i} {\n      left: random(120) - 20 + vw;\n      filter: blur((random(2)-1) + px);\n      animation:\n        ((random(20) + 20)/10) + s flicker (random(20) / -10) + s infinite,\n        ((random(100) + 50)/5) + s fall (random(100) / -5) + s infinite;\n    }\n  }\n\n  @for $i from 1 through $numberOfSnowflakeMd {\n    &._md-#{$i} {\n      left: random(120) - 20 + vw;\n      filter: blur((random(2)-1) + px);\n      animation:\n        ((random(20) + 20)/10) + s flicker (random(20) / -10) + s infinite,\n        ((random(100) + 50)/5) + s fall (random(100) / -5) + s infinite;\n    }\n  }\n\n  @for $i from 1 through $numberOfSnowflakeLg {\n    &._lg-#{$i} {\n      left: random(120) - 20 + vw;\n      animation:\n        ((random(20) + 20)/10) + s flicker (random(20) / -10) + s infinite,\n        ((random(100) + 50)/5) + s fall (random(100) / -5) + s infinite;\n    }\n  }\n}\n\n@keyframes flicker {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n}\n\n@keyframes fall {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  100% {\n    transform: translate(20vw, 110vh) rotate(360deg);\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
